import { render, staticRenderFns } from "./treatment_contracts.vue?vue&type=template&id=29023915&"
import script from "./treatment_contracts.vue?vue&type=script&lang=js&"
export * from "./treatment_contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports